import {
    ADD_ASSET_SELECTION, REMOVE_ASSET_SELECTION, INVALIDATE_ASSETS_SELECTION,
    ADD_COLLECTION_SELECTION, INVALIDATE_COLLECTION_SELECTION, UPDATE_RECIPIENT_NAMES, UPDATE_ATTACH_CONTENT, INVALIDATE_ATTACH_CONTENT,
    POPULATE_MEETING_DETAILS,
    PF_CHROME_WEBAPP_INVALIDATE_MEETING_DETAILS,
    POPULATE_DEAL_DETAILS,
    INVALIDATE_DEAL_DETAILS
  } from 'constants/actionTypes';
  
  import { createAction } from 'redux-actions';


  export const selectAsset = createAction(ADD_ASSET_SELECTION, (asset) => asset);
  
  export const deselectAsset = createAction(REMOVE_ASSET_SELECTION, (asset) => asset);
  
  export const invalidateAssetSelection = createAction(INVALIDATE_ASSETS_SELECTION);
  
  export const selectCollection = createAction(ADD_COLLECTION_SELECTION, (collection) => collection);

  export const invalidateCollectionSelection = createAction(INVALIDATE_COLLECTION_SELECTION);

  export const updateRecipientNames = createAction(UPDATE_RECIPIENT_NAMES, (recipientNames) => recipientNames);

  export const updateAttachContent = createAction(UPDATE_ATTACH_CONTENT, (context, items, html) => ({ context, items, html }));

  export const invalidateAttachContent = createAction(INVALIDATE_ATTACH_CONTENT);

  export const populateMeetingDetails = createAction(POPULATE_MEETING_DETAILS, (meetingDetails) => meetingDetails);

  export const invalidateMeetingDetails = createAction(PF_CHROME_WEBAPP_INVALIDATE_MEETING_DETAILS);

  export const populateDealDetails = createAction(POPULATE_DEAL_DETAILS, (dealDetails) => dealDetails);

  export const invalidateDealDetails = createAction(INVALIDATE_DEAL_DETAILS);